import {
    RECEIVE_POLL_VOTE_REGISTRATION
} from '../../actions/pollActions';

const PollVoteRegistrationReducer = (state = false, action) => {
    switch (action.type) {
        case RECEIVE_POLL_VOTE_REGISTRATION:
            return action.registered;

        default:
            return state;
    }
};

export default PollVoteRegistrationReducer;